
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["loadModel","detect"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "67d278fbde83fb0f8e57.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			